module.exports = __webpack_public_path__ + "static/03-6c07129022e286d50d1da5af14d28045.jpg";